var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS3 = function SvgS3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M25 8.472h-3.84a2.966 2.966 0 0 1-2.965-2.966v-3.84M25 8.473a4.7 4.7 0 0 0-1.375-3.32l-2.11-2.11a4.7 4.7 0 0 0-3.32-1.375M25 8.472V20.05A4.95 4.95 0 0 1 20.05 25H6.617a4.95 4.95 0 0 1-4.951-4.95V6.617a4.95 4.95 0 0 1 4.95-4.951h11.578M7.5 7.5h5.834M7.5 19.167h11.667M7.5 13.333h11.667"
  })));
};
export default SvgS3;